import { render, staticRenderFns } from "./SlideMarketplace.vue?vue&type=template&id=30805f3a&scoped=true"
import script from "./SlideMarketplace.vue?vue&type=script&lang=ts"
export * from "./SlideMarketplace.vue?vue&type=script&lang=ts"
import style0 from "./SlideMarketplace.vue?vue&type=style&index=0&id=30805f3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30805f3a",
  null
  
)

export default component.exports